import { render, staticRenderFns } from "./DocumentsTabBar.vue?vue&type=template&id=0840b03a"
import script from "./DocumentsTabBar.vue?vue&type=script&lang=js"
export * from "./DocumentsTabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports